import type { ReactNode } from 'react';

/**
 * Emptiness with a reason. A surface with nothing in it yet and a surface that failed
 * must never look the same, so every empty place says what would put something here.
 */
export function EmptyState({
  title,
  note,
  action,
}: {
  title: string;
  note: string;
  action?: ReactNode;
}): ReactNode {
  return (
    <div className="empty-state">
      <p className="empty-title">{title}</p>
      <p className="note">{note}</p>
      {action}
    </div>
  );
}

/** A refusal the operator can read, kept apart from emptiness on purpose. */
export function Failure({ message, onRetry }: { message: string; onRetry?: () => void }): ReactNode {
  return (
    <div className="failure" role="alert">
      <p>{message}</p>
      {onRetry === undefined ? null : (
        <button type="button" className="ghost" onClick={onRetry}>
          Повторить
        </button>
      )}
    </div>
  );
}
